import { __awaiter as c, __generator as s } from "./index11.js";
import { ContextCancelation as a, CoreContext as f } from "./index43.js";
function l(e) {
  return c(this, void 0, void 0, function() {
    var n;
    return s(this, function(r) {
      switch (r.label) {
        case 0:
          return r.trys.push([0, 2, , 3]), [4, e()];
        case 1:
          return [2, r.sent()];
        case 2:
          return n = r.sent(), [2, Promise.reject(n)];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function m(e, n) {
  e.log("debug", "plugin", { plugin: n.name });
  var r = (/* @__PURE__ */ new Date()).getTime(), o = n[e.event.type];
  if (o === void 0)
    return Promise.resolve(e);
  var i = l(function() {
    return o.apply(n, [e]);
  }).then(function(t) {
    var u = (/* @__PURE__ */ new Date()).getTime() - r;
    return t.stats.gauge("plugin_time", u, ["plugin:".concat(n.name)]), t;
  }).catch(function(t) {
    if (t instanceof a && t.type === "middleware_cancellation")
      throw t;
    return t instanceof a ? (e.log("warn", t.type, {
      plugin: n.name,
      error: t
    }), t) : (e.log("error", "plugin Error", {
      plugin: n.name,
      error: t
    }), e.stats.increment("plugin_error", 1, ["plugin:".concat(n.name)]), t);
  });
  return i;
}
function d(e, n) {
  return m(e, n).then(function(r) {
    if (r instanceof f)
      return r;
    e.log("debug", "Context canceled"), e.stats.increment("context_canceled"), e.cancel(r);
  });
}
export {
  m as attempt,
  d as ensure
};
//# sourceMappingURL=index67.js.map
